/**
 * Ryan O'Dowd
 * 2023-12-29
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import ListItem from '@components/ListItem';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const SettingCard = (props: SettingCardProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <ListItem
      onPress={props.onPress}
    >
      <View style={styles.rowWrapper}>
        <View style={styles.textWrapper}>
          <Text style={styles.title}>
            {props.title}
          </Text>
          <Text style={styles.subtitle}>
            {props.subtitle}
          </Text>
        </View>
        {props.actionItem &&
          <View style={styles.action}>
            {props.actionItem}
          </View>
        }
      </View>
      {props.bottomComponent}
    </ListItem>
  );
};

class SettingCardProps {
  subtitle: string;
  title: string;

  actionItem?: React.ReactNode;
  bottomComponent?: React.ReactNode;
  onPress?: () => void;
};

export default SettingCard;
